import StandardError from '../../StandardError'

export default class BannedProductError extends StandardError {
  constructor() {
    super('errors.cart.banned_product')
  }
}
